module.exports = __webpack_public_path__ + "static/media/icon-arrow.bff41657.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-arrow.svg
// module id = 255
// module chunks = 3